<template>
  <SmartLinkItemComponent
    custom-tag="div"
    class="accordion-list"
    :id="model.system.id"
    :component="!model.system.workflow"
  >
    <div :class="getClass()">
      <!-- Header -->
      <div class="header">
        <div class="acl-row">
          <SmartLinkStandaloneElement :codename="typ.elements.icon.codename" v-if="data.icon">
            <font-awesome class="icon fa-fw" :icon="data.icon" />
          </SmartLinkStandaloneElement>
          <SmartLinkStandaloneElement
            custom-tag="h2"
            class="title"
            :codename="typ.elements.title.codename"
          >
            {{ data.title }}
          </SmartLinkStandaloneElement>
        </div>

        <div class="acl-row" v-if="data.hasSubTitle">
          <SmartLinkStandaloneElement
            custom-tag="p"
            class="subtitle"
            :codename="typ.elements.title.codename"
          >
            <RichText :value="data.subTitle" />
          </SmartLinkStandaloneElement>
        </div>
      </div>
      <div class="accordion" :id="data.id">
        <AccordionItem
          v-for="(item, index) in data.items"
          :model="item"
          :index="getIndex(index)"
          :parent-id="data.id"
          :options="options"
        />
      </div>
    </div>
  </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { AccordionItemModel, AccordionListModel } from '~/models'
import type { AccordionOptions } from '~/models/options/accordionOptions'
import { contentTypes } from '~/models'
import type { AccordionListState } from '~/types/AccordionListState'
const typ = contentTypes.accordion_list

const pageStore = usePageStore()
const props = defineProps<{
  model: AccordionListModel
  options: AccordionOptions
}>()

const data = {
  id: `acl-${props.model.system.id}`,
  title: props.model.elements.title.value,
  subTitle: props.model.elements.subtitle.value,
  hasSubTitle: !!useSanitize(props.model.elements.subtitle.value, 'text'),
  icon: props.model.elements.icon.value,
  items: pageStore.getListAs<AccordionItemModel>(props.model.elements.accordionItems.value)
}

const accordionListState = useState<AccordionListState>('AccordionListState')

accordionListState.value.data.push(props.model)

function getIndex(index: number) {
  const idx = accordionListState.value.data.indexOf(props.model)
  if (idx <= 0) {
    return index
  }

  //we want to find all previous accordion sections and sum all their items to get the correct starting index
  var totalPreviousItems = 0
  for (let i = 0; i < idx; i++) {
    totalPreviousItems += accordionListState.value.data[i].elements.accordionItems.value.length
  }

  return totalPreviousItems + index
}
function getClass() {
  if (!props.options?.fromFaq) {
    return 'container'
  }
  return ''
}
</script>
